import { Controller } from "@hotwired/stimulus"
import { Sortable } from 'sortablejs'
import { patch } from '@rails/request.js'

// Connects to data-controller="conversion-actions--sortable"
//
// Drag-reorders the conversion-action list and persists the new order immediately.
// display_order follows the submitted id order (see ConversionActionSetting.reorder!).
// Reusable across surfaces (the CA-management page, its funnel pane, and the
// attribution-monitoring Events drawer) so the same order can be adjusted from either.
//
// Two shapes:
// - No section targets: the controller element IS the sortable container (drawer/funnel lists).
// - With section targets: each section is its own sortable (rows can't drag BETWEEN sections —
//   crossing the visibility split is the Show-in-reporting toggle's job), but persistence spans
//   them: ALL rows under the controller element post in DOM order, so the sections share ONE
//   logical display order (hidden-by-default rows take the tail positions).
export default class extends Controller {
  static targets = ["section"]
  static values = { url: String }

  connect() {
    const containers = this.hasSectionTarget ? this.sectionTargets : [this.element]
    this.sortables = containers.map((container) =>
      Sortable.create(container, {
        handle: '.sortable-handle',
        animation: 150,
        onEnd: () => this.#persist()
      })
    )
  }

  disconnect() {
    this.sortables?.forEach((sortable) => sortable.destroy())
  }

  #persist() {
    // Group rows ride the same ids[] payload as "group:<id>" entries, so action-only surfaces
    // (the attribution Events drawer) keep a byte-identical payload; the server partitions.
    const ids = Array.from(this.element.querySelectorAll('[data-conversion-action-id], [data-conversion-group-id]'))
      .map(el => el.dataset.conversionActionId ?? `group:${el.dataset.conversionGroupId}`)
      .filter(Boolean)
    patch(this.urlValue, { body: { ids } })
  }
}
